// Data for Projects Sections!
// Add a new ID for new projects & Style in CSS.
//
// `group`   places the project in one of the carousels below — must match a
//           projectGroups `name` or the project will not be rendered.
// `primary` is the single gold call-to-action pinned to the detail title row.
//           Omit it when a project has nothing to play, download or visit.
// `links`   at most one — the code repo. Two buttons total is the limit, so
//           nothing else (design boards, jam pages, etc.) belongs here.

export const projectGroups = [
    { name: 'Apps & Tools' },
    { name: 'Games' },
    { name: 'React Three.js' },
];

export const projectData = [
            {
                id: 9,
                group: 'Apps & Tools',
                title: 'Booked',
                miniTitle: '2026',
                subtitle: 'Reading Habits Dashboard',
                previewImage: '/Images/Apps/Booked-Card.jpg',
                media: [
                    { type: 'image', url: '/Images/Apps/Booked-Promo1.jpg' },
                    { type: 'image', url: '/Images/Apps/Booked-Promo2.jpg' },
                    { type: 'image', url: '/Images/Apps/Booked-Promo3.jpg' },
                ],
                technologies: ['React', 'TypeScript', 'Tailwind CSS', 'Recharts', 'Open Library API'],
                description: ['Booked is a dashboard that tracks the books I have read and turns them into statistics. It covers pages and estimated words, top authors and genres, alongside a filterable library view.',

                    'The aim of this project was to see how far careful planning could carry a build handed over to AI coding assistance. I wrote the requirements as three markdown specification files, then orchestrated the implementation from those rather than writing the site line by line, which got a clean and complete site standing up in a fraction of the usual time.',

                    'Book details come from the Open Library API with Google Books as a fallback, and the reading data is managed locally through a small Node and SQLite admin. The published site is a static export of that data, so it runs on Netlify with nothing to keep alive behind it.'
                ],
                primary: { label: 'Live Link', url: 'https://reading-dashboard.netlify.app/' },
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Web-Reading-Metrics' },
                ],
            },
            {
                id: 8,
                group: 'Apps & Tools',
                title: 'Web Health Monitor',
                miniTitle: '2026',
                subtitle: 'Self-Hosted Uptime Dashboard',
                previewImage: '/Images/Apps/WebHealth-Card.jpg',
                media: [
                    { type: 'image', url: '/Images/Apps/WebHealth-Promo1.jpg' },
                ],
                technologies: ['C#', '.NET 10', 'Blazor', 'SQLite', 'EF Core'],
                description: ['Web Health Monitor is a self-hosted dashboard that checks a list of sites every minute and reports whether each one is responding, the status code it returned, and how long it took.',

                    'The aim of this project was to build something I would actually run against my own sites rather than a worked example, so it had to handle the failure cases properly. A 404, a slow response and a domain that never resolves are three different problems, and the dashboard separates them rather than showing one red light.',

                    'To achieve this, a .NET background worker runs the checks and writes to SQLite through EF Core, keeping seven days of history and clearing anything older automatically. SQLite keeps the whole thing to a single file with no database server to host or pay for, which is why it runs locally rather than as a site I keep online.'
                ],
                // No primary CTA — it is a tool you clone and run, not a hosted site
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Web-Health-Monitor' },
                ],
            },
            {
                id: 1,
                group: 'React Three.js',
                title: 'Portfolio',
                miniTitle: '2024-Present',
                subtitle: 'React Three Fiber Application',
                previewImage: '/Images/ThreeJS/Portfolio-Promo1.jpg',
                media: [
                    { type: 'image', url: '/Images/ThreeJS/Portfolio-Promo1.jpg' },
                ],
                technologies: ['React', 'ThreeJs', 'JavaScript', 'Blender'],
                description: ['This portfolio was created using React Three Fiber to showcase my game development skills through a unique and interactive design. It features ' +
                    'custom 3D models that represent my work and personal interests in a stylized manner.',
    
                    'My goal was to develop a fully scalable and customizable portfolio that effectively highlights my projects. To achieve this, I utilized HTML, CSS, and ' +
                    'JavaScript with the React library, ensuring a responsive layout that adapts to any device while aligning with the sites theme.',
        
                    'I also prioritized a dynamic user experience, combining interactive 3D elements with intuitive functionality to create an engaging and personalized website.'
                ],
                // No primary CTA — you're already on the site this describes, so
                // a "Visit Site" button would just reload the page you're on.
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/React-Winter-Portfolio/tree/main/src' },
                ],
            },
            {
                id: 2,
                group: 'React Three.js',
                title: 'Procedural Terrain Shader',
                miniTitle: '2024',
                subtitle: 'Three.js Shader',
                previewImage: '/Images/ThreeJS/Procedural-Promo1.jpg',
                media: [
                    { type: 'image', url: '/Images/ThreeJS/Procedural-Promo1.jpg' },
                ],
                technologies: ['Three.js', 'Three bvh', 'GLSL Shaders'],
                description: ['This procedural terrain shader, created with Three.js, generates a realistic, customisable landscapes. ' +
                    'Leveraging custom vertex and fragment shaders, the terrain adapts dynamically with adjustable ' +
                    'settings for position frequency, warp strength, and color gradients.',
    
                    'The goal was to develop a flexible terrain generation system with a GUI for real-time adjustments, allowing for quick, responsive tuning ' + 
                    'of landscape features. Enhanced by an HDR skybox and custom lighting, the environment achieves a high level of realism with accurate ' + 
                    'reflections and shadows.',
        
                    'Key technical elements include high-resolution meshes, shadow-casting lights, and detailed materials for water and wood, creating ' +
                    'a visually immersive landscape ideal for interactive applications.'
                ],
                primary: { label: 'Live Link', url: 'https://proceduralterrainshader.netlify.app/' },
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/ThreeJS-Procedural-Terrain' },
                ],
            },
            {
                // COMPLETE
                id: 4,
                group: 'Games',
                title: 'Assembly Required',
                miniTitle: '2022',
                subtitle: 'Farming Roguelike Exploration',
                previewImage: '/Images/Games/Assembly-Promo9.jpg', 
                media: [
                    // Promo still leads; the trailer sits second for anyone who wants it
                    { type: 'image', url: '/Images/Games/Assembly-Promo1.jpg' },
                    { type: 'embed', url: 'https://www.youtube.com/embed/AQUKyF2cjNM?si=rlF7Eh-CtIbXYHyh' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo3.jpg' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo7.jpg' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo8.jpg' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo4.jpg' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo2.jpg' },
                    { type: 'image', url: '/Images/Games/Assembly-Promo5.jpg' },
                ],
                technologies: ['Unreal Engine 4', 'Blueprint', 'Jira'],
                description: ['Assembly Required is a third-person, farming rogue-like sci-fi exploration game developed in Unreal Engine 4. This team project was ' +
                    'completed over a 6-week development period during my time at university.',
    
                    'As a junior tech, I worked in a tech team of three, focusing on gaining hands-on experience while collaborating closely with a cross-discipline team. ',
        
                    'My contributions included developing core features such as the farming tool prototypes, refuel station, melee enemy, acid pools, level transitions, UI ' +
                    'implementation, sound manager, and reviewing level designs. I also assisted with bug fixing across various areas of the game.' 
                ],
                primary: { label: 'Download', url: 'https://tomwilkinson.itch.io/assembly-required' },
                links: [
                    { label: 'View Code', url: 'https://github.com/TomWilkinsonGames/RoboFarm' },
                ],
            },
            {
                id: 7,
                group: 'Games',
                title: 'Construction Catastrophe',
                miniTitle: '2023',
                subtitle: 'Four Player Co-Op Party',
                previewImage: '/Images/Games/Construction-Card.jpg',
                media: [
                    { type: 'image', url: '/Images/Games/Construction-Promo1.jpg' },
                    { type: 'image', url: '/Images/Games/Construction-Promo2.jpg' },
                    { type: 'image', url: '/Images/Games/Construction-Promo3.jpg' },
                    { type: 'image', url: '/Images/Games/Construction-Promo4.jpg' },
                    { type: 'image', url: '/Images/Games/Construction-Promo5.jpg' },
                    { type: 'image', url: '/Images/Games/Construction-Promo6.jpg' },
                ],
                technologies: ['Unreal Engine 5', 'Blueprint', 'Local Multiplayer'],
                description: ['Construction Catastrophe is a four-player local co-op party game built in Unreal Engine, where teams race to build their construction site before earthquakes, floods and meteor strikes bring it back down.',

                    'I came onto this university project as tech lead, and ended up covering producer and design lead as well when the team ran into difficulty. Alongside the code that meant running the schedule, mentoring two junior programmers and the design team, and keeping communication moving between tech, design and art across a group of fifteen.',

                    'On the technical side I owned the game logic, building the game manager that drives the build phase, the action phase and the menus between them. I also set up local multiplayer controller support for four players and built the character selection and customisation screens, and a good share of the remaining time went on unpicking issues across the juniors work so the build stayed shippable.'
                ],
                primary: { label: 'Download', url: 'https://mreaston.itch.io/constructioncatastrophe' },
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Game-3D-Construction-Catastrophe' },
                ],
            },
            {
                id: 3,
                group: 'Games',
                title: 'Tankeo Drift',
                miniTitle: '2024',
                subtitle: 'Endless Action Roguelike',
                previewImage: '/Images/Games/Tankeo-Promo2.jpg',
                media: [
                    { type: 'image', url: '/Images/Games/Tankeo-Promo2.jpg' },
                    { type: 'image', url: '/Images/Games/Tankeo-Promo1.jpg' },
                    { type: 'image', url: '/Images/Games/Tankeo-Promo3.jpg' },
                    { type: 'image', url: '/Images/Games/Tankeo-Promo4.jpg' },
                    { type: 'image', url: '/Images/Games/Tankeo-Promo5.jpg' },
                    { type: 'image', url: '/Images/Games/Tankeo-Promo6.jpg' },
                ],
                technologies: ['Unity', 'C#', 'Blender', 'Photoshop'],
                description: ['A solo project, covering the design, programming, art and audio. Tankeo Drift is an action-packed rogue-like game built in Unity, where you battle endless waves of enemies, gather experience, and upgrade your tank as you progress.',
    
                    'The aim of this project was to develop an endless rogue-like experience, inspired by Vampire Survivor, with a focus on an engaging upgrade system. ' +
                    'Additionally, I wanted to improve my 3D modelling skills.',
        
                    'To achieve this, I implemented a procedurally generated environment. The system uses a 9-tile grid of prefabs that dynamically update based on the ' +
                    'players position, creating the illusion of an infinite level.'
                ],
                primary: { label: 'Play on WebGL', url: 'https://jake12341234.itch.io/tankeo-drift' },
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Game-3D-Tankeo-Drift' },
                ],
            },
            {
                // COMPLETE
                id: 5,
                group: 'Games',
                title: 'Deliberation',
                miniTitle: '2024',
                subtitle: 'A* Pathfinding Prototype',
                previewImage: '/Images/Games/Deliberation-Promo1.jpg', 
                media: [
                    { type: 'image', url: '/Images/Games/Deliberation-Promo1.jpg' },
                    { type: 'image', url: '/Images/Games/Deliberation-PromoG.gif' },
                ],
                technologies: ['Unity', 'A* Pathfinding', 'Aseprite', 'Grid System'],
                description: ['A solo project, covering the design, programming, art and audio. Deliberation is a prototype puzzle game built in Unity that showcases A* pathfinding. Click to select your characters target position ' + 
                    'and watch the pathfinding in action.',
    
                    'The goal of this project was to explore different pathfinding algorithms, such as A*, Dijkstra, Depth-first, and Breadth-first and integrate them ' + 
                    'with lighting mechanics to create engaging puzzles. ',
        
                    'To achieve this, I expanded on an A* project I developed during university, incorporating pixel art and animations to bring the game to life.'
                ],
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Game-2D-Deliberation' },
                ],
            },
            {
                // COMPLETE
                id: 6,
                group: 'Games',
                title: 'AstroHaul',
                miniTitle: '2024',
                subtitle: 'Asteroids Gravity Chaos',
                previewImage: '/Images/Games/Asteroids-Promo1.jpg', 
                media: [
                    { type: 'image', url: '/Images/Games/Asteroids-Promo1.jpg' },
                    { type: 'image', url: '/Images/Games/Asteroids-Promo2.jpg' },
                    { type: 'image', url: '/Images/Games/Asteroids-Promo3.jpg' },
                ],
                technologies: ['Unity', 'C#', 'Aseprite'],
                description: ['A solo project, covering the design, programming, art and audio. AstroHaul is a 2D retro arcade game created in Unity based on the classic Asteroids game. This project was created as part of the Typical Game Jam (within 3 days).',
    
                'My goal for this project was to create a classic I enjoyed and give it a fresh look. I chose to utilise volatile gravitational fields and collection mechanics.',
    
                'To achieve this, I set out to make a gravitation push/pull effect usable for all objects. The idea was to add uncertainty while maintaining responsive feedback ' +
                'so users could understand these forces. '
                ],
                primary: { label: 'Play on WebGL', url: 'https://jake12341234.itch.io/astrohaul' },
                links: [
                    { label: 'View Code', url: 'https://github.com/Jake2508/Game-2D-AstroHaul' },
                ],
            },
    ];
